import { Box, Button, Heading, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/auth/AuthContext';
import TwoFactorSection from './TwoFactorSection';

const RequiredTwoFactorSetup = () => {
    const { t } = useTranslation('account');
    const { currentUser, refreshUser, logout } = useAuth();

    return (
        <Box minH="100vh" display="flex" justifyContent="center" alignItems="flex-start" p={{ base: 4, md: 10 }}>
            <VStack align="stretch" gap={5} w="full" maxW="720px">
                <Heading size="lg">{t('settingsPage.twoFactor.requiredTitle')}</Heading>
                <Text color="text.grey" fontSize="sm">{t('settingsPage.twoFactor.requiredDescription')}</Text>
                <TwoFactorSection
                    enabled={false}
                    email={currentUser?.email}
                    onChanged={refreshUser}
                />
                <Button variant="outlined" size="sm" alignSelf="flex-start" onClick={logout} type="button">
                    {t('settingsPage.twoFactor.requiredLogout')}
                </Button>
            </VStack>
        </Box>
    );
};

export default RequiredTwoFactorSetup;
